import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TranslocoModule } from '@jsverse/transloco';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { LucideAngularModule, UserCheck, Globe, Mail } from 'lucide-angular';

import { UserFormService } from '../services/user-form.service';

@Component({
  selector: 'app-user-informations',
  imports: [
    ButtonModule,
    InputTextModule,
    ReactiveFormsModule,
    ToastModule,
    SelectModule,
    ToggleSwitchModule,
    TranslocoModule,
    ChangePasswordComponent,
    LucideAngularModule,
  ],
  templateUrl: './user-informations.component.html',
  styleUrl: './user-informations.component.scss',
})
export class UserInformationsComponent implements OnInit {
  userFormService = inject(UserFormService);

  // Lucide icons
  readonly userCheckIcon = UserCheck;
  readonly globeIcon = Globe;
  readonly mailIcon = Mail;

  ngOnInit(): void {
    this.userFormService.reset();
  }
}
